import { render, staticRenderFns } from "./TabDefault.vue?vue&type=template&id=362fa7fd&scoped=true"
import script from "./TabDefault.vue?vue&type=script&lang=js"
export * from "./TabDefault.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "362fa7fd",
  null
  
)

export default component.exports